import { Box, Button, Select, Stack, TextField, Typography } from "@mui/material";
import ButtonBar from "../../components/button-bar/ButtonBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AuthenticationContext } from "../../components/authentication/AuthenticationContext";
import { Playlist } from "../../types/Playlist";
import { getPlaylist, postPlaylist } from "../../components/apis/music-api";
import { PlaylistType } from "../../types/PlaylistType";
import callApi from "../../components/call-api/call-api";

type EditPlaylistProps = {
    id: string,
}

const EditPlaylist = () => {
    const params = useParams<EditPlaylistProps>();
    const navigate = useNavigate();
    const { getAccessToken } = useContext(AuthenticationContext);
    const [ playlist, setPlaylist ] = useState<Playlist>({
        id: '',
        name: '',
        duration: 0,
        playlistType: PlaylistType.Unknown,
        playlistItems: [],
    });

    useEffect(() => {
        callApi<Playlist>(getPlaylist(getAccessToken(), params?.id ?? ''), setPlaylist);
    }, [getAccessToken, params?.id]);

    const save = async () => {
        await postPlaylist(getAccessToken(), playlist);
        navigate(`/playlists/${playlist.id}`);
    }

    const handleSave = () => {
        save();
    }

    return (
        <>
            <ButtonBar
                leftButtons={[
                    <Button component={Link} variant="contained" size="small" to={`/playlists/${playlist.id}`}>
                        <FontAwesomeIcon fontSize="large" color="primary" icon={faBan} className="icon"/>
                        Cancel
                    </Button>
                ]}
                rightButtons={[
                    <Button variant="contained" size="small" onClick={handleSave}>
                        <FontAwesomeIcon fontSize="large" color="primary" icon={faPenToSquare} className="icon"/>
                        Save Changes
                    </Button>
                ]}
            />
            <Stack direction="row" spacing={2} sx={{ justifyContent: 'center' }}>
                <Box sx={{ width: '628px' }}>
                    <Box sx={{ mb: '20px' }}><Typography variant="h6">Playlist Name</Typography></Box>
                    <Stack spacing={3}>
                        <Box>
                            <Select
                                native
                                id="playlist-type"
                                sx={{ width: '420px' }}
                                size="small"
                                label="Playlist Type"
                                value={playlist.playlistType}
                                onChange={(e) => setPlaylist({ ...playlist, playlistType: e.target.value as PlaylistType })}>
                                <option value={PlaylistType.Unknown}>Unknown</option>
                                <option value={PlaylistType.Artists}>Artists</option>
                                <option value={PlaylistType.Albums}>Albums</option>
                                <option value={PlaylistType.Tracks}>Tracks</option>
                            </Select>
                        </Box>
                        <Box>
                            <TextField 
                                id="playlist-name"
                                sx={{ width: '420px' }}
                                size="small"
                                label="Name"
                                InputLabelProps={{ shrink: true }}
                                variant="outlined" 
                                value={playlist?.name}
                                onChange={(e) => setPlaylist({ ...playlist, name: e.target.value })}
                            />
                        </Box>
                    </Stack>
                </Box>
            </Stack>
        </>
    );
}

export default EditPlaylist;